<template>
  <!-- 工作台——看板 -->
  <div class="board">
    <div class="head">
      <el-menu :default-active="questionType" mode="horizontal" active-text-color="var(--theme-color)" @select="handleSelect">
        <el-menu-item index="3">2D问题</el-menu-item>
        <el-menu-item index="1">3D问题</el-menu-item>
        <el-menu-item index="0">文件</el-menu-item>
        <el-menu-item index="2">计划</el-menu-item>
      </el-menu>
    </div>
    <div class="content">
      <!-- 问题看板 2D 3D 文件 -->
      <template v-if="questionType === '3' ||questionType === '1'||questionType === '0'">
        <questionBoard :question-type="questionType"></questionBoard>
      </template>
      <!-- 计划看板 -->
      <template v-if="questionType === '2'">
        <taskBoard></taskBoard>
      </template>
    </div>
  </div>
</template>

<script>
import questionBoard from "./components/questionBoard.vue";
import taskBoard from "./components/taskBoard.vue";

export default {
  name: "ProjectBoard",
  components: { questionBoard, taskBoard },
  data() {
    return {
      questionType: "3" // 当前问题类型：	3=2d问题，1=3d问题，0=文件问题
    };
  },
  mounted() {},
  methods: {
    // 切换看板
    handleSelect(index) {
      this.questionType = index;
    }
  }
};
</script>

<style lang='scss' scoped>
.board {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .head {
    width: 100%;
    background-color: white;
    border-radius: 4px 4px 0 0;
    overflow: hidden;

    .el-menu {
      padding-left: var(--big-space);
      border-bottom: 1px solid #e6eaf8;

      .el-menu-item {
        height: 46px;
        padding: 0;
        margin: 0 40px 0 0;
        font-family: "PingFang SC";
        font-weight: 700;
        font-size: 16px;
        line-height: 46px;
      }
    }
  }
  .content{
    width: 100%;
    height: 1px;
    flex-grow: 1;
    overflow-y: auto;
  }
}
</style>
